"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styles_1 = require("@material-ui/core/styles");
const SwipeableDrawer_1 = __importDefault(require("@material-ui/core/SwipeableDrawer"));
const List_1 = __importDefault(require("@material-ui/core/List"));
const core_1 = require("@material-ui/core");
const Menu_1 = __importDefault(require("@material-ui/icons/Menu"));
const SwipeListItem_1 = __importDefault(require("./SwipeListItem"));
const useStyles = styles_1.makeStyles((theme) => styles_1.createStyles({
    list: {
        width: 250,
    },
    fullList: {
        width: 'auto',
    },
    nested: {
        paddingLeft: theme.spacing(4),
    },
    paper: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.text.secondary
    }
}));
function SwipeableTemporaryDrawer(props) {
    const [state, setState] = react_1.default.useState({
        top: false,
        left: false,
        bottom: false,
        right: false,
    });
    const classes = useStyles();
    const toggleDrawer = (side, open) => (event) => {
        if (event &&
            event.type === 'keydown' &&
            (event.key === 'Tab' ||
                event.key === 'Shift')) {
            return;
        }
        setState({ ...state, [side]: open });
    };
    const sideList = (side) => (react_1.default.createElement("div", { className: classes.list, role: "presentation", onKeyDown: toggleDrawer(side, false) },
        react_1.default.createElement(List_1.default, null, props.navButtons.map((navBarButton, index) => react_1.default.createElement(SwipeListItem_1.default, { key: index, navButton: navBarButton })))));
    return (react_1.default.createElement("div", null,
        react_1.default.createElement(core_1.IconButton, { onClick: toggleDrawer('right', true), edge: "start", color: "inherit", "aria-label": "menu" },
            react_1.default.createElement(Menu_1.default, null)),
        react_1.default.createElement(SwipeableDrawer_1.default, { classes: { paper: classes.paper }, open: state.right, onClose: toggleDrawer('right', false), onOpen: toggleDrawer('right', true) }, sideList('right'))));
}
exports.default = SwipeableTemporaryDrawer;
//# sourceMappingURL=SwipeableDrawerKTR.js.map